/// <reference path="./utils/modules.d.ts"/>
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as Raven from 'raven-js';
import { AppContainer } from 'react-hot-loader';

import '../config/polyfills.js';
import './components/index.scss';
import App from './containers/App/App';

if (typeof window !== 'undefined') {
  const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate || ReactDOM.render;
  const render = (Component: React.ComponentType) => {
    renderMethod(
      <AppContainer>
        <Component />
      </AppContainer>,
      document.getElementById('root'),
    );
  };

  // for Sentry error tracking
  if (process.env.NODE_ENV === 'production') {
    Raven.config('https://bcab1f5443a94afc92208f8eee3d55d7@sentry.cdn77.eu/25').install();
    Raven.context(() => {
      render(App);
    });
  } else {
    render(App);
  }

  if (module.hot) {
    module.hot.accept('./containers/App/App', () => {
      render(require('./containers/App/App').default);
    });
  }
}

export default App;



// WEBPACK FOOTER //
// /www/client/src/index.tsx